import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { VariantPickerCollection, VariantPickerSharedProperties, VariantPickerVariation_Plain } from "./utils";
import { ProductAttributeHeadline } from "./ProductAttributeHeadline";
import { StyledList, StyledListElement } from "./ListView";
import cn from "classnames";
import { PlainVariantView } from "./variations/PlainVariantView";
import React from "react";
import { PDPAction } from "../state/types";

export const PlainPicker: ReactTFC<{
  headline: string;
  disabled: boolean;
  attributes: VariantPickerCollection<VariantPickerVariation_Plain & { reactKey: string }>;
}> = props => {
  return (
    <>
      <ProductAttributeHeadline disabled={props.disabled} headline={props.headline} />

      <StyledList className={"one-per-line gridless one js-plain-picker"}>
        {props.attributes.values.map(v => {
          const { reactKey, target, state } = v;
          const className = cn(state === "selected" ? "active" : state === "disabled" ? "disabled" : "enabled");

          return (
            <StyledListElement key={reactKey} className={className}>
              <PlainVariantView variation={v} action={target} className={className} />
            </StyledListElement>
          );
        })}
      </StyledList>
    </>
  );
};
